import { Material, Province } from "./canvasTypes";

export const MaterialMapBlack: Map<Material, Map<Province, number>> = new Map([
  [
    Material.Spigots,
    new Map([
      [Province.Quebec, 70],
      [Province.Ontario, 79],
    ]),
  ],
  [
    Material.Pannel180Attachemnt,
    new Map([
      [Province.Quebec, 28],
      [Province.Ontario, 28],
    ]),
  ],
  [
    Material.Pannel90Attachemnt,
    new Map([
      [Province.Quebec, 28],
      [Province.Ontario, 28],
    ]),
  ],
  [
    Material.WallAttachment,
    new Map([
      [Province.Quebec, 28],
      [Province.Ontario, 28],
    ]),
  ],
  [
    Material.AdjustableAttachement,
    new Map([
      [Province.Quebec, 38],
      [Province.Ontario, 38],
    ]),
  ],
  [
    Material.DoorLatch,
    new Map([
      [Province.Quebec, 85],
      [Province.Ontario, 175],
    ]),
  ],
  [
    Material.FloorLock,
    new Map([
      [Province.Quebec, 120],
      [Province.Ontario, 120],
    ]),
  ],
  [
    Material.HingeKit,
    new Map([
      [Province.Quebec, 280],
      [Province.Ontario, 275],
    ]),
  ],
]);

export const MaterialMapSilver: Map<Material, Map<Province, number>> = new Map([
  [
    Material.AdjustableAttachement,
    new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 35],
    ]),
  ],
  [
    Material.Pannel90Attachemnt,
    new Map([
      [Province.Quebec, 25],
      [Province.Ontario, 25],
    ]),
  ],
  [
    Material.WallAttachment,
    new Map([
      [Province.Quebec, 25],
      [Province.Ontario, 25],
    ]),
  ],
  [
    Material.Spigots,
    new Map([
      [Province.Quebec, 66],
      [Province.Ontario, 69],
    ]),
  ],
  [
    Material.Pannel180Attachemnt,
    new Map([
      [Province.Quebec, 25],
      [Province.Ontario, 25],
    ]),
  ],
  [
    Material.DoorLatch,
    new Map([
      [Province.Quebec, 75],
      [Province.Ontario, 150],
    ]),
  ],
  [
    Material.FloorLock,
    new Map([
      [Province.Quebec, 100],
      [Province.Ontario, 100],
    ]),
  ],
  [
    Material.HingeKit,
    new Map([
      [Province.Quebec, 200],
      [Province.Ontario, 250],
    ]),
  ],
]);

export const MaterialNameMap: Map<Material, Map<Province, string>> = new Map([
  [
    Material.AdjustableAttachement,
    new Map([
      [Province.Quebec, "Attache ajustable"],
      [Province.Ontario, "Adjustable Connectors"],
    ]),
  ],
  [
    Material.Pannel90Attachemnt,
    new Map([
      [Province.Quebec, "Attache 90"],
      [Province.Ontario, "90 Connectors"],
    ]),
  ],
  [
    Material.WallAttachment,
    new Map([
      [Province.Quebec, "Attache mur"],
      [Province.Ontario, "Wall Connectors"],
    ]),
  ],
  [
    Material.Spigots,
    new Map([
      [Province.Quebec, "Spigot"],
      [Province.Ontario, "Spigots"],
    ]),
  ],
  [
    Material.Pannel180Attachemnt,
    new Map([
      [Province.Quebec, "Attache 180"],
      [Province.Ontario, "180 Connectors"],
    ]),
  ],
  [
    Material.DoorLatch,
    new Map([
      [Province.Quebec, "Verrou aimanté"],
      [Province.Ontario, "Door Latch"],
    ]),
  ],
  [
    Material.FloorLock,
    new Map([
      [Province.Quebec, "Verrou de plancher"],
      [Province.Ontario, "Floor Lock"],
    ]),
  ],
  [
    Material.HingeKit,
    new Map([
      [Province.Quebec, "Penture (2)"],
      [Province.Ontario, "Hinge Kit (2)"],
    ]),
  ],
]);
